import { motion } from 'framer-motion';
import React from 'react';
import './style.scss';

interface JUNOSwitchProps {
  id: number;
  initialState: boolean;
  toggle_side: 'left' | 'right';
  switch_title: string;
  handleChange: (initialState: boolean) => void;
  switch_subtitle?: string;
  disabled?: boolean;
}

const JUNOSwitch: React.FC<JUNOSwitchProps> = ({
  id,
  initialState,
  toggle_side,
  switch_title,
  handleChange,
  switch_subtitle,
  disabled,
}) => {
  const handleClick = e => {
    handleChange(!initialState);
  };

  const className = `JUNOSwitch ${toggle_side} ${initialState ? 'on' : 'off'}`;
  return (
    <motion.div layout transition={spring} key={`switch_${id}`} className={className}>
      <div className="switch_container">
        <input className="checkbox" type="checkbox" checked={initialState} onChange={handleClick} disabled={disabled} />
        <span className="slider"></span>
      </div>
      <div className="main_container">
        <div className="switch_text_container">
          <div className="switch_title">{switch_title}</div>
          <div className="switch_subtitle">{switch_subtitle}</div>
        </div>
      </div>
    </motion.div>
  );
};

const spring = {
  type: 'spring',
  stiffness: 700,
  damping: 30,
};

export default JUNOSwitch;
